import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const uploadFile = async (urlData) => {
  return base.postFile({ url: API_PARAM.DATASETS, data: urlData});
};

export const getUploadedFileStatus = async (id) => {
  return base.get({
    url: `${API_PARAM.DATASETS}/${id}`,
  });
};
